import { clearSelection } from "action/garage/clearSelection";
import { selectVehicle } from "action/garage/selectVehicle";
import { getVehiclesFromBrowserState } from "api/garage/getVehiclesFromBrowserState";
import Slider from "component/design-system/carousel/Slider";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import { VEHICLE_FITMENT } from "constant/shared-constants";
import { RootState } from "interfaces/generics.type";
import HorizontalProductCard from "modules/components/product-cards/horizontal-product-card/HorizontalProductCard";
import { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import HideIf from "util/HideIf";
import { equalVehicles } from "util/vehicle/equal-vehicles";
import { validateVehicle } from "util/vehicle/validate-vehicle";
import styles from "./recently-liked-slider.module.scss";

function RecentlyLikedSlider() {
  const { savedItems } = useSelector((store: RootState) => store.shoppingCart);
  const { selectedVehicle, vehicles: savedVehicles } = useSelector((store: RootState) => store.garage);
  const isLoadingSession = useSelector((state: RootState) => state.authenticationState.refreshStatus !== "complete");
  const dispatch = useDispatch();
  const selectValue = selectedVehicle
    ? { label: `${selectedVehicle.year} ${selectedVehicle.make} ${selectedVehicle.model}`, value: selectedVehicle }
    : { label: "All", value: "all" };
  const [vehicleOptions, setVehicleOptions] = useState([]);
  const vehicleSpecificSavedItems = validateVehicle(selectedVehicle)
    ? savedItems.filter((savedItem) => savedItem.fitment === VEHICLE_FITMENT.UNIVERSAL || equalVehicles(savedItem.vehicles[0], selectedVehicle))
    : savedItems;

  function handleSelectVehicle(selectedValue) {
    if (selectedValue.value === "all") {
      dispatch(clearSelection());
      return;
    }
    dispatch(selectVehicle(selectedValue.value));
  }
  useEffect(() => {
    getVehiclesFromBrowserState()
      .then(({ vehicles }) => {
        const options = vehicles.map((vehicle) => ({
          label: `${vehicle.year} ${vehicle.make} ${vehicle.model}`,
          value: vehicle,
        }));
        setVehicleOptions([{ label: "All", value: "all" }, ...options]);
      });
  }, [savedVehicles.length]);

  if (isLoadingSession || vehicleOptions.length === 0) {
    return <Skeleton height={101} count={5} />;
  }

  return (
    <div className={styles.recently_liked_container}>
      <div className={styles.recently_liked_heading}>
        <i className="fa fa-heart" />
        <PAText
          component="p"
          className="m-b-0"
          fontSize={FONT_SIZE[3]}
          bold
        >
          Recently Liked

        </PAText>
        <Select
          className={styles.garage_slider}
          value={selectValue}
          options={vehicleOptions}
          // placeholder={`${t("Select a Department")}*`}
          onChange={handleSelectVehicle}
          classNamePrefix="react-select"
        />
      </div>
      <HideIf show={vehicleSpecificSavedItems.length === 0}>
        <PAText component="p" bold className="text-center" fontSize={FONT_SIZE[2]}>
          {validateVehicle(selectedVehicle)
            ? `No items saved for ${selectedVehicle?.year} ${selectedVehicle?.make} ${selectedVehicle?.model}`
            : "There are no items saved in your wishlist"}

        </PAText>
      </HideIf>
      <Slider
        tileWidth={400}
        showArrowOnHover
        showScrollOnHover
      >
        {
          vehicleSpecificSavedItems.map((product) => (
            <HorizontalProductCard
              key={product.description}
              product={product}
            />
          ))
        }
      </Slider>
    </div>
  );
}

export default RecentlyLikedSlider;
